import { render, staticRenderFns } from "./SubmerchantAdd.vue?vue&type=template&id=cf3d642a&"
import script from "./SubmerchantAdd.vue?vue&type=script&lang=js&"
export * from "./SubmerchantAdd.vue?vue&type=script&lang=js&"
import style0 from "./SubmerchantAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports